import { apiAction } from '../actions/api';
import { loadGame, loadGameHistory, loadGameRanking } from '../actions/game';
import { loadContenders, resetSimulation } from '../actions/simulation';
import { GRADE_FINISH_SUCCESS } from '../constants/grades';
import { FM_SAVE_REVISION_SUCCESS } from '../constants/filemanager';
import { SIMULATION_FINISH } from '../constants/simulation';
import {
  GAME_LEVEL_UP_SUCCESS,
  GAME_CHANGE_LEVEL_SUCCESS,
} from '../constants/game';

const GAME_REFRESH_TRIGGERS = [
  GRADE_FINISH_SUCCESS,
  FM_SAVE_REVISION_SUCCESS,
  SIMULATION_FINISH,
];

const gameMiddleware = ({ dispatch, getState }) => (next) => {
  return (action) => {
    const isGameMode = getState().app.gameMode;

    if (isGameMode && GAME_REFRESH_TRIGGERS.includes(action.type)) {
      dispatch(
        apiAction(
          [
            'GAME_REFRESH_START',
            'GAME_REFRESH_SUCCESS',
            'GAME_REFRESH_FAILURE',
          ],
          (api) => api.getGame()
        )
      )
        .then((json) => json.game)
        .then((game) => {
          dispatch(loadGame(game))
          dispatch(loadGameHistory())
          dispatch(loadGameRanking())
        });
    }

    /* Reload a few things from API when changing levels */
    if (
      isGameMode &&
      (action.type === GAME_LEVEL_UP_SUCCESS ||
        action.type === GAME_CHANGE_LEVEL_SUCCESS)
    ) {
      dispatch(loadContenders());
      dispatch(resetSimulation());
    }

    /* Load additional information when leveling up to Level 5 */
    if (isGameMode && action.type === GAME_LEVEL_UP_SUCCESS) {
      if (action.result?.activity?.game?.level?.level === 5) {
        dispatch(loadGameHistory());
        dispatch(loadGameRanking());
      }
    }

    return next(action);
  };
};

export default gameMiddleware;
